import { useEffect, useState } from "react";

interface ModalHeaderProps {
    open: boolean;
    title: string;
    icon: React.ReactNode;
    disabled: boolean;
    onClose: () => void;
    onMinimize: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ open, title, icon, disabled, onClose, onMinimize }) => {
    const [minimize, setMinimize] = useState(false)

    useEffect(() => {
        if (!open) return
        setMinimize(false)
    }, [open])

    return (
        <div className='feature__modal__header__container'>
            <div className='header__container__title__section'>
                {icon}
                {title}
            </div>
            <div className='header__container__button__section'>
                <button className='header__button__container'
                    onClick={() => {
                        setMinimize(!minimize)
                        onMinimize()
                    }}
                >
                    {!minimize ? <i className='fe fe-minus' /> : <i className='fe fe-plus' />}
                </button>
                <button className='header__button__container'
                    disabled={disabled}
                    onClick={onClose}
                >
                    <i className='fe fe-x' />
                </button>
            </div>
        </div>
    )
}

export default ModalHeader